module.exports = __webpack_public_path__ + "static/media/pineapple.1b07fc8f.png";